import { render, staticRenderFns } from "./HeaderSagres.vue?vue&type=template&id=6f35e968"
import script from "./HeaderSagres.vue?vue&type=script&lang=ts"
export * from "./HeaderSagres.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports